import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d1a8ab18"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_2 = { class: "route-plan-stop__times" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

import { computed, PropType } from 'vue'
import { Route, RouteStop } from '@/models/public/routePlanner.model'

import { formatIntlTime, formatMinutesToDuration } from '@/utils/formatters'
import { differenceInMinutes } from 'date-fns'
import { calculateServiceETA } from '../../../utils/route-planner'
import { CATEGORIES, FORMATS, SIZES } from '@/enums/components'
import BaseButton from '@/components/BaseButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RoutePlanStop',
  props: {
  route: {
    type: Object as PropType<Route>,
    required: true,
  },
  stop: {
    type: Object as PropType<RouteStop>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['click', 'onRefresh', 'onDelete'],
  setup(__props, { emit: emits }) {

const props = __props





const idleTime = computed(() => getIdleTime())
const times = computed(() => {
  const timePeriod = `${formatIntlTime(
    props.stop.start_time,
  )} - ${formatIntlTime(props.stop.end_time)}`
  if (idleTime.value) {
    return `${timePeriod}, ooteaeg ${idleTime.value}`
  }
  return timePeriod
})

const getIdleTime = () => {
  const eta = calculateServiceETA(props.stop.service, props.route)
  if (!eta || !props.stop.start_time) {
    return
  }
  const minutes = differenceInMinutes(props.stop.start_time, eta)
  return formatMinutesToDuration(minutes)
}

const handleDelete = (event) => {
  event.stopPropagation()
  event.preventDefault()
  emits('onDelete')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["route-plan-stop", [__props.disabled && 'route-plan-stop__disabled']]),
    onClick: _cache[1] || (_cache[1] = () => emits('click', __props.stop.service))
  }, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("div", null, _toDisplayString(`${__props.stop.service.name} (${__props.stop.service.company_name})`), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(times)), 1)
    ]),
    (!props.stop?.start_time && !props.stop?.end_time && !__props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(BaseButton, {
            format: _unref(FORMATS).ICON_CIRCULAR,
            size: _unref(SIZES).SMALL,
            "icon-size": 16,
            type: "button",
            icon: "refresh",
            onClick: _cache[0] || (_cache[0] = () => emits('onRefresh'))
          }, null, 8, ["format", "size"])
        ]))
      : _createCommentVNode("", true),
    (!__props.disabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(BaseButton, {
            format: _unref(FORMATS).ICON_CIRCULAR,
            size: _unref(SIZES).SMALL,
            category: _unref(CATEGORIES).DELETE,
            "icon-size": 16,
            type: "button",
            icon: "trash-bin",
            onClick: handleDelete
          }, null, 8, ["format", "size", "category"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})